module.exports = __webpack_public_path__ + "static/media/ARROZM_MENU-normal.d2455274.png";